import React, { FC } from 'react';
import { CircularProgress } from '@mui/material';

interface LoaderProps {
  className?: string
}

const Loader: FC<LoaderProps> = ({ className }) => (
  <div className={`loader-page ${className}`}>
    <CircularProgress color='inherit' />
  </div>
);

export default Loader;
